<template>
  <div class="container">
    <Breadcrumb :path="path"></Breadcrumb>
    <div class="stepsBox">
      <van-steps :active="active" active-color="#E60012">
        <van-step>已受理</van-step>
        <van-step>处理中</van-step>
        <van-step>已办结</van-step>
        <van-step>已评价</van-step>
      </van-steps>
      <div class="bottom">
        <div class="leftBox">
          <div class="left">
            <span class="title">问题ID：</span>
            <span>{{ detail.table && detail.table.id }}</span>
          </div>
          <div class="center">
            <span class="title">发起时间：</span>
            <span>{{ detail.table && detail.table.create_time }}</span>
          </div>
        </div>
        <div class="rightBox">
          <img src="../../assets/img/ysl.png" v-if="detail.table && detail.table.status == 1" />
          <img src="../../assets/img/clz.png" v-else-if="detail.table && detail.table.status == 2" />
          <img src="../../assets/img/ybj.png" v-else-if="detail.table && detail.table.status == 3" />
          <img src="../../assets/img/ypj.png" v-else />
        </div>
      </div>
    </div>
    <div class="line"></div>
    <div class="content">
      <div class="mainBox">
        <div class="left">主题</div>
        <div class="right">{{ detail.table && detail.table.title }}</div>
      </div>
      <div class="mainBox">
        <div class="left">建议类型</div>
        <div class="right">
          {{
            detail.table && detail.table.type == 1
            ? "管理创新"
            : detail.table && detail.table.type == 2
              ? "流程制度改进"
              : detail.table && detail.table.type == 3
                ? "市场营销方案"
                : detail.table && detail.table.type == 4
                  ? "降本增效"
                  : detail.table && detail.table.type == 5
                    ? "行政建设"
                    : detail.table && detail.table.type == 6
                      ? "企业文化建设"
                      : detail.table && detail.table.type == 7
                        ? "其他"
                        : ""
          }}
        </div>
      </div>
      <div class="mainBox">
        <div class="left">反馈方式</div>
        <div class="right">
          {{ detail.table && detail.table.feed_type == 1 ? "实名" : "匿名" }}
        </div>
      </div>
      <div class="mainBox" v-if="detail.table && detail.table.feed_type == 1">
        <div class="left">申请人</div>
        <div class="right">{{ detail.table && detail.table.real_name }}</div>
      </div>
      <div class="mainBox" v-if="detail.table && detail.table.feed_type == 1">
        <div class="left">联系方式</div>
        <div class="right">{{ detail.table && detail.table.mobile }}</div>
      </div>
    </div>
    <div class="content">
      <div class="mainBox mainBoxBottom">
        <div class="left">建议事由</div>
        <div class="right">{{ detail.table && detail.table.feedback_obj }}</div>
      </div>
      <div class="mainBox mainBoxBottom">
        <div class="left">改善建议</div>
        <div class="right">
          {{ detail.table && detail.table.feedback_content }}
        </div>
      </div>
      <div class="mainBox mainBoxBottom">
        <div class="left">预期效果</div>
        <div class="right">{{ detail.table && detail.table.for_result }}</div>
      </div>
      <div class="mainBox mainBoxBottom imgFileBox" v-if="detail.table && detail.table.files.length > 0">
        <div class="left" style="padding-right: 10px">附件</div>
        <!-- {{ detail.table.files }} -->
        <template v-for="(item, index) in detail.table.files">
          <div class="right" :key="index">
            <div class="name" style="display: block;">
              {{ item.file_name }}
            </div>
            <div class="size">{{ (item.file_size / 10000).toFixed(2) }}kb</div>
            <div class="btn">
              <button class="view">
                <a :href="item.file_full_url" target="_blank" style="color: #333">查看
                </a>
              </button>
              <button class="down" @click="downloadImage(item.file_full_url, item.file_name)">
                下载
              </button>
            </div>
          </div>
          <div class="videoBox" v-if="item.file_type == 1" :key="index">
            <video class="video"></video>
            <div class="btn">
              <button class="view">
                <a :href="item.file_full_url" target="_blank" style="color: #333">查看
                </a>
              </button>
              <button class="down" @click="downloadImage(item.file_full_url, item.file_name)">
                下载
              </button>
            </div>
          </div>
        </template>
      </div>

      <div class="content" v-if="active == 2 || active == 3">
        <div class="mainBox mainBoxBottom">
          <div class="left">处理结果</div>
          <div class="right">
            {{ detail.result && detail.result.feedback_result }}
          </div>
        </div>
        <div class="mainBox mainBoxBottom">
          <div class="left">相关文件</div>
          <div class="right-big-box">
            <template v-for="(item, index) in detail.result.files">
              <div class="right" :key="index">
                <div class="name">
                  {{ item.file_name }}
                </div>
                <div class="size">
                  {{ (item.file_size / 10000).toFixed(2) }}kb
                </div>
                <div class="btn">
                  <button class="view">
                    <a :href="item.file_full_url" target="_blank" style="color: #333">查看
                    </a>
                  </button>
                  <button class="down" @click="downloadImage(item.file_full_url, item.file_name)">
                    下载
                  </button>
                </div>
              </div>
            </template>
          </div>
        </div>
        <div class="mainBox mainBoxBottom" id="bottomRadio">
          <div class="left" style="text-align: right">满意度评价</div>
          <div class="right">
            <van-radio-group v-model="form.radio" direction="horizontal" v-if="active == 2">
              <van-radio checked-color="#ee0a24" icon-size="22px" name="5">非常满意</van-radio>
              <van-radio checked-color="#ee0a24" icon-size="22px" name="4">满意</van-radio>
              <van-radio checked-color="#ee0a24" icon-size="22px" name="3">一般</van-radio>
              <van-radio checked-color="#ee0a24" icon-size="22px" name="2">不满意</van-radio>
              <van-radio checked-color="#ee0a24" icon-size="22px" name="1">非常不满意</van-radio>
            </van-radio-group>
            <div class="evaluation" v-if="active == 3">
              {{
                detail.result && detail.result.star_by_result == 1
                ? "非常不满意"
                : detail.result && detail.result.star_by_result == 2
                  ? "不满意"
                  : detail.result && detail.result.star_by_result == 3
                    ? "一般"
                    : detail.result && detail.result.star_by_result == 4
                      ? "满意"
                      : detail.result.star_by_result == 5
                        ? "非常满意"
                        : ""
              }}
              （已选）
            </div>
            <textarea class="textarea" style="resize: none; word-break: break-all" :placeholder="`请输入选择${form.radio == 3
                          ? '一般'
                          : form.radio == 2
                            ? '不满意'
                            : form.radio == 1
                              ? '非常不满意'
                              : ''
                        }的原因`" name="text" v-model="content" id="" cols="30" rows="10"
              v-if="form.radio <= 3 && active == 2"></textarea>
          </div>
        </div>
        <div class="mainBox mainBoxBottom" v-if="detail.result.result_commend.length != 0">
          <div class="left">评价原因</div>
          <div class="right">
            {{ detail.result && detail.result.result_commend }}
          </div>
        </div>
      </div>
      <div class="line"></div>

      <div class="btnBox mainBoxBottom">
        <div class="subBtn" @click="subBtn" v-if="detail.table && detail.table.status == 3">
          提交
        </div>
        <div :class="detail.table && detail.table.status == 3 ? 'cancel1' : 'cancel'
          " @click="cancel" v-if="detail.table && detail.table.status != 3">
          返回
        </div>
      </div>
    </div>
    <van-popup class="popup" v-model="show">
      <img src="../../assets/img/success.png" alt="" />
      <div class="title">评价成功</div>
      <div class="titleInf">感谢你的反馈</div>
    </van-popup>
  </div>
</template>

<script>
import { $get_feedback, $add_feedback_comment } from "../../api";
import Breadcrumb from "../../components/Breadcrumb";
import { message } from "ant-design-vue";
export default {
  name: "suggestionDetail",
  props: {},
  data () {
    return {
      show: false, // 弹出层
      active: "", // 步骤条
      form: {
        radio: "5",
      },
      detail: {}, // 表单数据
      content: "", // 评价内容
    };
  },
  components: {
    Breadcrumb,
  },

  computed: {
    path () {
      let arr = [
        { name: "首页", names: "Home" },
        { name: "我的问题反馈", names: "feedback" },
        { name: "合理化建议详情", names: "suggestionDetail" },
      ];
      return arr;
    },
  },

  activated () { },
  created () { },
  async mounted () {
    try {
      let res = await $get_feedback({ id: this.$route.query.id });
      this.detail = res.data;
      this.active = res.data.table.status - 1;
    } catch (error) {
      console.log(error);
    }
  },
  methods: {
    downloadImage (url, name) {
      console.log(11);
      var xhr = new XMLHttpRequest();
      xhr.open("GET", url, true);
      xhr.responseType = "blob";
      xhr.onload = function () {
        if (xhr.status === 200) {
          var urlCreator = window.URL || window.webkitURL;
          var imageUrl = urlCreator.createObjectURL(xhr.response);
          var tag = document.createElement("a");
          tag.href = imageUrl;
          tag.download = name;
          document.body.appendChild(tag);
          tag.click();
          document.body.removeChild(tag);
        }
      };
      xhr.send();
    },
    async subBtn () {
      try {
        let params = {
          id: this.detail.table.id,
          star: this.form.radio,
          content: this.content,
        };
        if (
          this.form.radio != 5 &&
          this.form.radio != 4 &&
          this.content == ""
        ) {
          if (this.windowWidth() > 767) {
            message.success("请填写评价原因");
          } else {
            this.$toast.success("请填写评价原因");
          }
          return;
        } else {
          let res = await $add_feedback_comment(params);
          setTimeout(() => {
            this.show = false;
            this.$router.push({ name: "feedback" });
          }, 3000);
          this.form.radio = "5";
          this.show = true;
          this.content = "";
        }
      } catch (error) {
        console.log(error);
      }
    },
    // 详情页返回
    cancel () {
      // this.$router.back();
      this.$router.push({
        name: this.windowWidth() > 767 ? "feedback" : "feedbacks",
        query: {
          current: this.$route.query.current,
          status: this.$route.query.status,
          tpye: this.$route.query.tpye,
          value: this.$route.query.value,
        },
      });
    },
    // 弹出层，返回首页
    backHome () {
      this.$router.push("/home");
      this.show = false;
    },
  },
};
</script>

<style lang="less" scoped>
@media (min-width: 767px) {
  .container {
    max-width: 1280px;
    height: auto;
    background: #ffffff;
    margin: 16px auto;
    padding: 26px 85px;

    .stepsBox {
      width: 1108px;
      height: 163px;
      background: #f7f8fc;
      margin: 25px auto;
      padding-top: 34px;
      padding-bottom: 24px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;

      /deep/.van-steps {
        background-color: transparent;
        width: 500px;
        margin: 0 auto;
      }

      /deep/.van-step__circle-container {
        padding: 0;
        background-color: transparent;

        .van-step__circle {
          width: 13px !important;
          height: 13px !important;
        }
      }

      /deep/.van-step__icon {
        font-size: 18px;
      }

      .bottom {
        .leftBox {
          display: flex;
          align-items: flex-end;
          justify-content: center;

          .center {
            margin: 0 54px;
          }

          .title {
            font-size: 16px;
            font-family: PingFang SC;
            font-weight: 500;
            color: #666666 !important;
          }

          span {
            font-size: 16px;
            font-family: PingFang SC;
            font-weight: 500;
            color: #333333;
          }
        }

        .rightBox {
          display: none;
        }
      }
    }

    .line {
      width: 100%;
      height: 1px;
      background: #cfcfcf;
      // border: 1px solid #CFCFCF;
    }

    .content {
      .mainBox {
        display: flex;
        margin: 20px 0;
        // align-items: center;

        .left {
          position: relative;
          font-size: 18px;
          font-family: PingFang SC;
          font-weight: 500;
          color: #666666;
          text-align: right;
          min-width: 120px;
          padding-right: 10px;
        }

        .left::after {
          position: absolute;
          content: "：";
        }

        .right-big-box {
          display: flex;
          flex-wrap: wrap;
        }

        .right {
          display: flex;
          flex-wrap: wrap;
          flex-direction: column;
          justify-content: space-between;
          font-size: 18px;
          font-family: PingFang SC;
          font-weight: 500;
          color: #333333;
          margin-left: 16px;
          margin-bottom: 30px;

          .name {
            margin-bottom: 16px;
          }

          .textarea {
            margin-top: 15px;
            width: 647px;
            height: 90px;
            background: #ffffff;
            border: 1px solid #cfcfcf;
            padding-top: 13px;
            padding-left: 16px;
          }

          .textarea::placeholder {
            font-size: 18px;
            font-family: PingFang SC;
            font-weight: 500;
            color: #999999;
          }

          .view {
            width: 91px;
            height: 41px;
            background: #eeeeee;
            border-radius: 4px;
            font-size: 18px;
            font-family: PingFang SC;
            font-weight: 500;
            color: #333333;
            text-align: center;
            line-height: 41px;
            cursor: pointer;
            margin-right: 11px;
          }

          .down {
            width: 91px;
            height: 41px;
            background: #ffeaec;
            border-radius: 4px;
            font-size: 18px;
            font-family: PingFang SC;
            font-weight: 500;
            color: #e60012;
            text-align: center;
            line-height: 41px;
            cursor: pointer;
          }

          .size {
            font-size: 18px;
            font-family: PingFang SC;
            font-weight: 500;
            color: #999999;
            margin-bottom: 17px;
          }
        }

        // 预览视频
        .videoBox {
          height: 127px;
          margin-left: 40px;
          padding-left: 39px;
          border-left: 1px solid #cfcfcf;

          .video {
            width: 117px;
            height: 77px;
            background-color: #333333;
          }

          .btn {
            margin-top: 10px;

            .view {
              width: 91px;
              height: 41px;
              background: #eeeeee;
              border-radius: 4px;
              font-size: 18px;
              font-family: PingFang SC;
              font-weight: 500;
              color: #333333;
              text-align: center;
              line-height: 41px;
              cursor: pointer;
              margin-right: 11px;
            }

            .down {
              width: 91px;
              height: 41px;
              background: #ffeaec;
              border-radius: 4px;
              font-size: 18px;
              font-family: PingFang SC;
              font-weight: 500;
              color: #e60012;
              text-align: center;
              line-height: 41px;
              cursor: pointer;
            }
          }
        }
      }

      #bottomRadio {
        display: flex;
        // align-items: center;
        // background-color: red;
      }
    }

    .btnBox {
      display: flex;
      margin-left: 118px;
    }

    .line {
      width: 100%;
      height: 1px;
      background: #cfcfcf;
      // border: 1px solid #CFCFCF;
      margin: 30px 0;
    }

    .subBtn {
      width: 122px;
      height: 49px;
      background: #e60012;
      border-radius: 4px;
      font-size: 20px;
      font-family: PingFang SC;
      font-weight: 500;
      color: #ffffff;
      line-height: 49px;
      text-align: center;
      margin-right: 10px;
      cursor: pointer;
    }

    .cancel {
      width: 122px;
      height: 49px;
      background: #e60012;
      border-radius: 4px;
      line-height: 49px;
      font-size: 20px;
      font-family: PingFang SC;
      font-weight: 500;
      color: #ffffff;
      text-align: center;
      cursor: pointer;
    }

    .cancel1 {
      width: 122px;
      height: 49px;
      background: #e1e1e1;
      border-radius: 4px;
      line-height: 49px;
      font-size: 20px;
      font-family: PingFang SC;
      font-weight: 500;
      color: #ffffff;
      text-align: center;
      cursor: pointer;
    }

    .popup {
      width: 472px;
      height: 301px;
      background: #ffffff;
      border-radius: 4px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;

      .title {
        font-size: 22px;
        font-family: PingFang SC;
        font-weight: 800;
        color: #333333;
        margin: 13px 0 8px 0;
      }

      .titleInf {
        font-size: 18px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #666666;
      }

      .cancel {
        width: 122px;
        height: 49px;
        background: #e60012;
        border-radius: 4px;
        line-height: 49px;
        text-align: center;

        margin-top: 33px;
      }
    }
  }
}

@media (max-width: 767px) {
  .container {
    padding: 20px 16px;
    margin: 0 auto;
    background-color: #fff;

    .line {
      width: 100%;
      height: 1px;
      background-color: #a1a1a1;
    }

    .stepsBox {
      height: 117px;
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;

      // 步骤条
      .van-steps {
        display: none;
      }

      .bottom {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;

        .leftBox {
          .center {
            margin: 10px 0;
          }

          .left,
          .center,
          .right {
            font-size: 15px;
            font-family: PingFang SC;
            font-weight: 500;
            color: #333;

            .title {
              width: 75px;
              font-size: 15px;
              font-family: PingFang SC;
              font-weight: 500;
              color: #666666 !important;
            }
          }

          .right {
            display: flex;

            .title-id {
              width: 175px;
              white-space: nowrap;
              // text-overflow: ellipsis;
              overflow: hidden;
            }
          }
        }

        .rightBox {
          display: block;
          width: 74px;
          height: 57px;
          flex-shrink: 0;

          img {
            width: 100%;
            height: 100%;
          }
        }
      }
    }

    .content {
      .mainBox {
        display: flex;
        align-items: center;
        justify-content: space-between;
        border-bottom: 1px solid #e5e5e5;
        padding: 25px 0;

        .left {
          font-size: 15px;
          font-family: PingFang SC;
          font-weight: 500;
          color: #666666;
        }

        .right {
          font-size: 15px;
          font-family: PingFang SC;
          font-weight: 500;
          color: #333333;

          .size {
            display: none;
          }
        }
      }

      .mainBoxBottom {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        padding: 20px 0;
        border-bottom: 1px solid #e5e5e5;

        .right-big-box {
          width: 100%;

          .right {
            width: 100%;
            display: flex;
            justify-content: space-between;
            margin-bottom: 10px;
            align-items: center;


            .name {
              width: 180px;
              // height: 20px;
              // white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            }

            .view {
              width: 70px;
              height: 33px;
              background: #f5f5f5;
              font-size: 15px;
              font-family: PingFang SC;
              font-weight: 500;
              color: #333333;
              text-align: center;
              line-height: 33px;
            }

            .down {
              width: 70px;
              height: 33px;
              background: #ffe4e6;
              font-size: 15px;
              font-family: PingFang SC;
              font-weight: 500;
              color: #e60012;
              text-align: center;
              margin-left: 7px;
              line-height: 33px;
            }
          }
        }

        .left {
          font-size: 15px;
          font-family: PingFang SC;
          font-weight: 500;
          color: #666666;
          margin-bottom: 10px;
        }

        .right {
          font-size: 15px;
          font-family: PingFang SC;
          font-weight: 500;
          color: #333333;
        }

        .textarea {
          margin-top: 10px;
          width: 100%;
          height: 50px;
        }

        .textarea::placeholder {
          font-size: 18px;
          font-family: PingFang SC;
          font-weight: 500;
          color: #999999;
        }
      }

      /deep/.van-radio--horizontal {
        margin-bottom: 15px;
        display: flex;
        align-items: center;
      }

      .imgFileBox {
        padding: 25px 0;
        border-bottom: 1px solid #e5e5e5;

        .left {
          width: 100%;

          font-size: 15px;
          font-family: PingFang SC;
          font-weight: 500;
          color: #666666;
          margin-bottom: 10px;
        }

        .right {
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: space-between;
          font-size: 15px;
          font-family: PingFang SC;
          font-weight: 500;
          color: #333333;
          margin-bottom: 10px;
          flex-wrap: wrap;

          .name {
            width: 180px;
            // height: 20px;
            // white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }

          .btn {
            font-size: 15px;

            .view {
              width: 70px;
              height: 33px;
              background: #f5f5f5;
              text-align: center;
              color: #333;
            }

            .down {
              width: 70px;
              height: 33px;
              background: #ffe4e6;
              text-align: center;
              color: #e60012;
              margin-left: 7px;
            }
          }
        }

        .videoBox {
          width: 100%;

          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-top: 10px;

          .video {
            width: 108px;
            height: 67px;
            background: #000000;
            opacity: 0.48;
          }

          .btn {
            font-size: 15px;

            .view {
              width: 70px;
              height: 33px;
              background: #f5f5f5;
              text-align: center;
              color: #333;
            }

            .down {
              width: 70px;
              height: 33px;
              background: #ffe4e6;
              text-align: center;
              color: #e60012;
              margin-left: 7px;
            }
          }
        }
      }

      .subBtn,
      .cancel {
        margin: 23px auto;
        width: 343px;
        height: 40px;
        background: #ea4949;
        border-radius: 5px;
        font-size: 15px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #ffffff;
        text-align: center;
        line-height: 40px;
      }

      .cancel1 {
        margin: 23px auto;
        width: 343px;
        height: 40px;
        background: #ea4949;
        border-radius: 5px;
        font-size: 15px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #ffffff;
        text-align: center;
        line-height: 40px;
      }
    }
  }

  .popup {
    width: 339px;
    height: 243px;
    background: #ffffff;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;

    img {
      width: 50px;
      height: 50px;
    }

    .title {
      width: 77px;
      height: 19px;
      font-size: 19px;
      font-family: PingFang SC;
      font-weight: 800;
      color: #333333;
      line-height: 8px;
      margin: 10px 0;
    }

    .titleInf {
      width: 85px;
      height: 13px;
      font-size: 14px;
      font-family: PingFang SC;
      font-weight: 500;
      color: #666666;
      line-height: 20px;
    }
  }
}
</style>
